"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SALES_STATUS_BADGE = void 0;
exports.SALES_STATUS_BADGE = {
    NEW: 'NEW',
    TRENDING: 'TRENDING',
    ON_SALE: 'ON_SALE',
    BESTSELLER: 'BESTSELLER'
};
//# sourceMappingURL=salesStatusBadge.js.map